import { useCallback, useState } from 'react';
import { EPhoneVerificationStep } from '../constants';

export const useVerificationStep = () => {
  const [step, setStep] = useState<EPhoneVerificationStep>(EPhoneVerificationStep.PHONE);
  const gotToPhoneStep = useCallback(() => setStep(EPhoneVerificationStep.PHONE), []);
  const goToVerificationStep = useCallback(() => setStep(EPhoneVerificationStep.VERIFY), []);

  return {
    step,
    gotToPhoneStep,
    goToVerificationStep,
  };
};
